import { AbstractCanvas, AbstractCanvasProps } from './abstractcanvas.tsx';
import { ThisOrThatData } from './thisorthat.tsx';

class ThisOrThatCanvas extends AbstractCanvas<ThisOrThatData> {
  constructor(props: AbstractCanvasProps<ThisOrThatData>) {
      super(props)
      this.draw=this.draw.bind(this)
    }

  componentDidMount() {
    this.draw()
  }
  draw() {
    const thisorthatcanvas = this.canvasRef.current
    if (thisorthatcanvas === null) {
      return;
    }
    const context = thisorthatcanvas.getContext('2d')
    if (context === null) {
      return;
    }

    
    const outputImage = this.imageRef.current;
    if (outputImage === null) {
      return;
    }

    
    //Our first draw
    context.font = "bold 30px Courier New";
    let textToDisplay = this.props.currentChallengeData.left.map(
      (left, i) => left + " OR " + this.props.currentChallengeData.right[i]
    )
    let widthToBe = 0
    let i = 1
    let height=150
    for (const line of textToDisplay) {
      if (context.measureText(line).width+30 > widthToBe) {
        widthToBe = context.measureText(line).width+100
      }
      i++
      height+=30
    }

    let title="snap.scrap.repeat"
    let subtitle="Scrapbook This OR That Challenge"
    let instructions = "Create a scrapbook layout using ONE of each of the following..."
    let footer="Generated by snapscraprepeat.com"

    context.font = "bold 30px Montserrat"
    let space=context.measureText(subtitle).width + 50
    widthToBe=Math.max(space,widthToBe)
    

    widthToBe = Math.max(height,widthToBe)
    context.canvas.width = widthToBe
    context.canvas.height = widthToBe
    context.fillStyle = '#ffffff'
    context.fillRect(0, 0, context.canvas.width, context.canvas.height)
    context.fillStyle = '#000000'
    i=1
    for (var line of textToDisplay) {
      console.log(line,0,i*30)
      context.font = "bold 30px Courier New";
      line = line.replace("~"," ")
      let space=context.canvas.width-context.measureText(line).width
      context.fillText(line,(space)/2,i*30+145)
      i++
    }
    context.font = "bold 20px Montserrat"
    space=context.canvas.width-context.measureText(title).width
    context.fillText(title,(space)/2,45)
    context.font = "bold 30px Montserrat"
    space=context.canvas.width-context.measureText(subtitle).width
    context.fillText(subtitle,(space)/2,80)
    context.font = "bold 15px Montserrat"
    space=context.canvas.width-context.measureText(instructions).width
    context.fillText(instructions,(space)/2,120)
    context.font = "bold 15px Montserrat"
    space=context.canvas.width-context.measureText(footer).width
    context.fillText(footer,(space)/2,context.canvas.height-30)
    
    context.lineWidth=40
    context.strokeStyle="#84E095"
    context.strokeRect(0, 0, context.canvas.width, context.canvas.height)

    context.lineWidth=20
    context.strokeStyle="#f1aec9"
    context.strokeRect(0, 0, context.canvas.width, context.canvas.height)

    outputImage.src = thisorthatcanvas.toDataURL()
  }
}

export default ThisOrThatCanvas